export default {"src":"/_next/static/media/map.c0bbe10b.svg","height":16,"width":16};